import type { ReactNode } from 'react';

export const symbol_theaters: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-180v30.18q0 12.82-8.68 21.32-8.67 8.5-21.5 8.5-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-660q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v30h120v-30.18q0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h220q12.75 0 21.38 8.62Q620-822.75 620-810v30h120v-30.18q0-12.82 8.68-21.32 8.67-8.5 21.5-8.5 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v660q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-30H620v30.18q0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H370q-12.75 0-21.37-8.63Q340-137.25 340-150v-30H220Zm0-60h120v-120H220v120Zm0-180h120v-120H220v120Zm0-180h120v-120H220v120Zm400 360h120v-120H620v120Zm0-180h120v-120H620v120Zm0-180h120v-120H620v120ZM400-180h160v-600H400v600Zm0-600h160-160Z"
		/>
	</svg>
);
